import { useState, useEffect } from "react";
import "./formStyle.scss";
import { useNavigate } from "react-router-dom";
import { z, ZodType } from "zod";
import axios from "axios";
import { notification } from "antd";

// icon
import {
  userIcon,
} from "../../constants/icons";

// utils
import monitorInputChange from "../../utils/monitorInputChange";

// interface
import { ErrorParams } from "../../interfaces/errorParams";
interface ResetPasswordData {
  email: string;
}

type NotificationType = "success" | "info" | "warning" | "error";

const API = '/api/v1';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [formdata, setFormdata] = useState<ResetPasswordData>({
    email: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [errorParams, setErrorParams] = useState<ErrorParams[]>([]);
  const resetPasswordSchema: ZodType<ResetPasswordData> = z.object({
    email: z.string().email(),
  });

  const opNotification = (
    type: NotificationType,
    message: string,
    descripton: string
  ) => {
    api[type]({
      message: message,
      description: descripton,
    });
  };



  const handleValidation = () => {
    let errorlist: any[] = [];
    const validation = resetPasswordSchema.safeParse(formdata);
    if (!validation.success) {
      const { errors } = validation.error;
      errors.forEach((err) => {
        errorlist.push({
          path: err.path[0],
          message: err.message,
        });
      });
    }
    setErrorParams(errorlist);

    if (errorlist.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const handleResetPasswordRequest = async() =>{
    try {
        setLoading(true)
        const validate = handleValidation();
        if(!validate){
            return false;
        }
        const res = await axios.post(`${API}/auth/resetpw/request`, formdata)
        if(res.status === 200 && res.data.success === true){
            return navigate('/auth/signin?action=rpwreq&status=success')
        }
    } catch (error:any) {
        if(error.status === 400 && error.response.data.error === "Invalid Account"){
          opNotification("error", 'Invalid Account', 'Account does not exists!')
        }
        // console.error("Error requesting resetting password: ",error)
    }
    finally{
        setLoading(false)
    }
  }


  useEffect(() => {
    if (errorParams.length > 0) {
      errorParams.forEach((err) => {
        let ele = document.getElementById(err.path);
        if (ele) {
          ele.style.borderColor = "#FF7875";
        }
      });
    }
    // eslist-disable-next-line
  }, [errorParams]);

  return (
    <div className="formContainer">
      {contextHolder}
      <span className="title">Reset Password</span>
      <form
        className="formHolder"
        onSubmit={(e) => {
          e.preventDefault();
          handleResetPasswordRequest();
        }}
      >
        
        <div className="inputHolder" id="email">
          <div className="iconHolder">{userIcon}</div>
          <input
            type="email"
            id="email"
            value={formdata.email}
            onChange={(e) => {
              setFormdata({
                ...formdata,
                email: e.target.value,
              });
              monitorInputChange("email");
            }}
            placeholder="E-mail"
          />
        </div>

        <button
          type="submit"
          className="submit"
          disabled={loading ? true : false}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <div className="formfooter">
          <span>Or</span>
          <span
            className="link"
            onClick={() => {
              navigate("/auth/signin");
            }}
          >
            Sign in!
          </span>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
